import React from 'react';
import ReactECharts from 'echarts-for-react';

const MetricsChart = () => {
  const option = {
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#334155',
      textStyle: { color: '#f8fafc' }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: ['D-14', 'D-12', 'D-10', 'D-8', 'D-6', 'D-4', 'D-2'],
      axisLine: { lineStyle: { color: '#334155' } },
      axisLabel: { color: '#94a3b8', fontFamily: 'JetBrains Mono' }
    },
    yAxis: {
      type: 'value',
      splitLine: { lineStyle: { color: '#1e293b', type: 'dashed' } },
      axisLabel: { color: '#94a3b8', fontFamily: 'JetBrains Mono' }
    },
    series: [
      {
        name: 'Waitlist Signups',
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 8,
        itemStyle: { color: '#f97316' },
        lineStyle: { color: '#f97316', width: 3 },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(249, 115, 22, 0.3)' },
              { offset: 1, color: 'rgba(249, 115, 22, 0.0)' }
            ]
          }
        },
        data: [120, 180, 250, 390, 520, 810, 1050]
      },
      {
        name: 'Social Impressions (k)',
        type: 'line',
        smooth: true,
        symbol: 'none',
        itemStyle: { color: '#3b82f6' },
        lineStyle: { color: '#3b82f6', width: 2, type: 'dashed' },
        data: [50, 70, 65, 120, 180, 220, 310]
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />;
};

export default MetricsChart;